import Vue from 'vue'
import App from './App.vue'
import Form from './components/Form.vue'
import Results from './components/Results.vue'
import vClickOutside from 'v-click-outside'
import VueRouter from 'vue-router'

Vue.config.productionTip = false

Vue.use(VueRouter)
Vue.use(vClickOutside)

const router = new VueRouter({
    mode: 'history',
    base: 'eligibility-search',
    routes: [
        { path: '/', component: Form, name: 'home' },
        { path: '/results', component: Results, name: 'results' }
    ],
});

new Vue({
    router,
    render: h => h(App),
}).$mount('#app')
